"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var material_ui_image_1 = require("material-ui-image");
var carImageWithBgStyles_1 = require("./carImageWithBgStyles");
var core_1 = require("@material-ui/core");
var CarImageWithBg = function (_a) {
    var isBackgroundDefault = _a.isBackgroundDefault, imageSrc = _a.imageSrc, interiorImg = _a.interiorImg, backgroundImg = _a.backgroundImg;
    var styles = carImageWithBgStyles_1.default();
    var theme = core_1.useTheme();
    var isMobile = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    var handleResponsiveVehicleImage = function () {
        if (!isMobile) {
            if (!isBackgroundDefault) {
                return {
                    root: __assign({}, carImageWithBgStyles_1.carImageStyles.withSpecialBackground),
                    vehicle: __assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImageithSpecialBackground),
                };
            }
            return { root: __assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImageRoot), vehicle: __assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImage) };
        }
        else {
            return {
                root: __assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImageRoot),
                vehicle: __assign(__assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImage), { height: '100%', width: '100%', top: '25%', objectFit: 'contain' }),
            };
        }
    };
    return (<core_1.Box className={styles.imageContainer}>
      {isBackgroundDefault && (<core_1.Box className={styles.bgContainer}>
          <material_ui_image_1.default src={backgroundImg} style={carImageWithBgStyles_1.carImageStyles.backgroundImageRoot} imageStyle={carImageWithBgStyles_1.carImageStyles.backgroundImage} disableSpinner={true}/>
          <material_ui_image_1.default src={interiorImg} style={carImageWithBgStyles_1.carImageStyles.interiorImageRoot} imageStyle={carImageWithBgStyles_1.carImageStyles.interiorImage}/>
        </core_1.Box>)}

      <material_ui_image_1.default src={imageSrc} style={handleResponsiveVehicleImage().root} imageStyle={handleResponsiveVehicleImage().vehicle}/>
    </core_1.Box>);
};
exports.default = CarImageWithBg;
